define('plugin/push-notifications/view/PushNotificationsView',['require','lib/view/LayoutView','Config','lib/view/ModalRegion'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');
    var ModalRegion = require('lib/view/ModalRegion');
    /**
     *
     * @class TelegramNotificationsView
     */
    return LayoutView.extend({

        template: '#push_subscribe_view',

        ui: {
             subscribeBtn: '#subscribe-client-push-btn',
             cancelBtn: '#cancel-client-push-btn',
            // pushSuccessBlock: '.push-success'
        },

        modelEvents: {
            'sync': 'render',
            'change': 'render'
        },

        events: {
            'click @ui.subscribeBtn' : 'onSubscribe',
            'click @ui.cancelBtn' : 'onCancel'
        },

        _bodyClass: 'has-push-alert',

        _clientModel : null,

        initialize: function () {
            this._clientModel = this.getOption('clientModel');

            this.initPushNotifyObj();
            LayoutView.prototype.initialize.apply(this);
        },


        onBeforeShow : function () {
            //console.log(this.ui.subscribeBtn);
        },


        serializeData: function () {
            var data = LayoutView.prototype.serializeData.apply(this);
            var token = data.token;
            var tokens = data.tokens;

            if(token && _.isArray(tokens)) {
                data.is_subscribed = tokens.map(function (item) {
                    return item.token;
                }).indexOf(token) !== -1;
            }

            data.is_visible =  !data.is_subscribed && data.client_id && data.status != 'disabled';
            //console.log(data);
            this.triggerMethod('hide:close:button', data.is_visible);
            return data;
        },

        onSubscribe : function () {
            var _this = this;
            this.triggerMethod('subscribe:push:notifications');
        },

        onCancel : function () {
            var _this = this;
            this.triggerMethod('cancel:push:notifications');
        },

        _performSubscribe : function(){

        },

        initPushNotifyObj : function () {

        },

        //Igor ask to add class
        _addBodyClass : function (add){
            if(add){
                jQuery('body').addClass(this._bodyClass);
            } else{
                jQuery('body').removeClass(this._bodyClass);
            }
        },

    });

});
